import { theme, george, pr, ui } from "aaa";
import { observer } from "mobx-react";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { safeWindowOpen } from "util/helpers";
import { HandoverURLTestRoutes } from "./HandoverURLTestRoutes";

export const HandoverURLTestOverview = observer(() => {
    const BackgroundComponent = externalInterfaceStore.isGeorgeApp ? george.Background : george.BackgroundWithNavBar;
    const [customUrl, setCustomUrl] = React.useState<string>("");

    const handleButtonClick = () => {
        const urlToRedirect = customUrl.trim() || HandoverURLTestRoutes.ROOT;
        safeWindowOpen(urlToRedirect);
    };

    return (
        <BackgroundComponent style={{ paddingTop: 48, paddingBottom: theme.MARGIN }}>
            <div style={pr.STYLE_CENTERED_CARD}>
                <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                    Handover URL Test
                </pr.P_22_TITLE>
                <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                    This page is publicly accessible and does not require authentication. You can use this page to test the handover to George.
                </pr.P_16_CONTENT>
                <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C", marginTop: 16 }}>
                    Use the input field below to specify a custom URL for testing navigation. If left empty, it will use the default route.
                </pr.P_16_CONTENT>
                <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C", marginTop: 8 }}>
                    All URLs will be opened using safeWindowOpen for consistent behavior.
                </pr.P_16_CONTENT>

                <div style={{ marginTop: 24, marginBottom: 16 }}>
                    <pr.P_16_CONTENT style={{ lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C", marginBottom: 8 }}>
                        Enter custom URL (optional):
                    </pr.P_16_CONTENT>
                    <input
                        type="text"
                        value={customUrl}
                        onChange={(e) => setCustomUrl(e.target.value)}
                        placeholder={HandoverURLTestRoutes.ROOT}
                        style={{
                            width: "100%",
                            padding: "12px 16px",
                            border: `1px solid ${ui.isDarkMode ? "#444" : "#ddd"}`,
                            borderRadius: "8px",
                            backgroundColor: ui.isDarkMode ? "#333" : "white",
                            color: ui.isDarkMode ? "white" : "#0A285C",
                            fontSize: "16px",
                            outline: "none"
                        }}
                    />
                </div>

                <george.SuccessButton
                    label="Navigate to URL"
                    onClick={handleButtonClick}
                    style={{ marginTop: 24, position: "relative", bottom: "auto" }}
                />
            </div>

        </BackgroundComponent>
    );
});


// WEBPACK FOOTER //
// ./src/components/handoverURLTest/HandoverURLTestOverview.tsx